import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.options.list('type', 'Type', TYPE_OPTIONS).multi(true),
    filter.boolean('private', 'Private'),
  ], [])
}

const TYPE_OPTIONS = [
  { value: 'input', label: 'Text' },
  { value: 'integer', label: 'Integer' },
  { value: 'select', label: 'Option' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'date', label: 'Date' },
]
